var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('b',[_vm._v(_vm._s(_vm.tday)+" дней [ "+_vm._s(_vm.thour)+" : "+_vm._s(_vm.tmin)+" : "+_vm._s(_vm.tsec)+" ]")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }